/**
 * What a rename box starts from: the room's STORED name, or nothing.
 *
 * Never the title the box sits under — that is spelled out for reading
 * ("livingRoom" → "Living room"), or derived from a section label or the
 * room's id when it has no name, and saving it back would rename the room:
 * pressing Enter on an unnamed room used to save its section label or its id
 * as its name. Shared by the room panel and the project's room cards.
 */
export const roomNameEditSeed = (room) =>
  typeof room?.name === 'string' ? room.name : '';
